<!-- 解决方案资料 -->
<template>
  <div class="plan-read-info-view">
    <p class="info-title">解决方案资料</p>

    <div class="plan-read-info-block">
      <div class="ly-container__bg">
        <div class="ly_operation">
          <div class="left">
            <UploadFile :buttonText="'上传附件'" @success="e => uploadFactoryDoc(e, '1')"/>

            <el-button @click="handleDeletes(0)">
              批量删除
              <i class="jr-iconjr-icon-delect" />
            </el-button>
          </div>
        </div>
      </div>

      <el-table style="width: 871px;" :data="solutionDocList"
      :header-cell-style="{ background: '#F5F6F7' }"
      @selection-change="solutionDocChange">
        <el-table-column type="selection" align="center" />

        <el-table-column prop="name" label="附件名称" align="center"></el-table-column>

        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="{ row }">
            <button-table content="下载" icon="jr-iconjr-icon-download" @buttonClick="downloadFactoryDoc(row)"/>
            <button-table content="查看" icon="jr-iconjr-icon-eye" @buttonClick="handleView(row)"/>
            <button-table content="编辑" icon="jr-iconjr-icon-edit" @buttonClick="handleEdit(row)"/>
            <button-table content="删除" icon="jr-iconjr-icon-delect" @buttonClick="handleDelete(row)"/>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <p class="info-title">中性版解决方案资料</p>

    <div class="plan-read-info-block">
      <div class="ly-container__bg">
        <div class="ly_operation">
          <div class="left">
            <UploadFile :buttonText="'上传附件'" @success="e => uploadFactoryDoc(e, '2')"/>

            <el-button @click="handleDeletes(1)">
              批量删除
              <i class="jr-iconjr-icon-delect" />
            </el-button>
          </div>
        </div>
      </div>

      <el-table style="width: 871px;" :data="neutralSolutionDocList"
      :header-cell-style="{ background: '#F5F6F7' }"
      @selection-change="neutralSolutionDocChange">
        <el-table-column type="selection" align="center" />

        <el-table-column prop="name" label="附件名称" align="center"></el-table-column>

        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="{ row }">
            <button-table content="下载" icon="jr-iconjr-icon-download" @buttonClick="downloadFactoryDoc(row)"/>
            <button-table content="查看" icon="jr-iconjr-icon-eye" @buttonClick="handleView(row)"/>
            <button-table content="编辑" icon="jr-iconjr-icon-edit" @buttonClick="handleEdit(row)"/>
            <button-table content="删除" icon="jr-iconjr-icon-delect" @buttonClick="handleDelete(row)"/>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <FileUploadPopup :show="popupShow" @close="popupShow = false" @uploadSuccess="handleUploadSuccess"/>
  </div>
</template>

<script>
import { getSolutionFile, updateSolutionFile } from "@/api/solvePlan.js"
import ButtonTable from "@/components/ButtonTable.vue";
import UploadFile from "@/components/UploadFile.vue";
import FileUploadPopup from "@/components/FileUploadPopup/index.vue"
// utils
import { downFile } from '@/utils/tool';

export default {
  components: {
    ButtonTable,
    UploadFile,
    FileUploadPopup
  },
  data() {
    //这里存放数据
    return {
      popupShow: false,
      editId: null,
      queryParams: [],
      solutionDocChooseList: [],
      neutralDocChooseList: [],
    };
  },
  computed: {
    solutionDocList() {
      if(Array.isArray(this.queryParams)) {
        return this.queryParams.filter(item => {
          return item.fileType == 1
        })
      } else {
        return []
      }
    },
    neutralSolutionDocList() {
      if(Array.isArray(this.queryParams)) {
        return this.queryParams.filter(item => {
          return item.fileType == 2
        })
      } else {
        return []
      }
    }
  },
  methods: {
    getInfo() {
      getSolutionFile({id: this.$route.query.companyCode}).then(res => {
        if(Array.isArray(res.data)) {
          this.queryParams = res.data;
        }
      })
    },
    downloadFactoryDoc(row) {
      console.log(row);
      downFile(
				{ urlStr: this.getSeverFileUrl(row.fileName) }, // 后台需要的参数
				'/public/downloadUrlFile', // 路径
        null,
				row.name //下载文件名称
			);
    },
    handleEdit(row) {
      this.editId = row.id;
      this.popupShow = true;
    },
    handleUploadSuccess(e) {
      const index = this.queryParams.findIndex(item => {
        return item.id === this.editId
      })

      this.popupShow = false;
      if(index === -1) {
        this.$message.error("修改失败");
      } else {
        this.queryParams[index].name = e.name;
        this.queryParams[index].fileName = e.url;
        this.submit(true)
      }
    },
    handleDelete(row) {
      const index  = this.queryParams.findIndex(item => {
        return item.id === row.id
      })

      this.$confirm("确认删除此条附件吗 ?", "提示")
        .then(async () => {
          if(index === -1) {
            this.$message.error("删除失败");
          } else {
            this.queryParams.splice(index, 1)
            this.submit(true, true)
          }
        })
        .catch(() => {});
    },
    handleView(row) {
      window.open(this.getSeverFileUrl(row.fileName)); 
    },
    submit(flag = false, deleteFlag = false) {
      this.$modal.loading('正在保存数据，请稍候...');

      updateSolutionFile(this.queryParams).then(res => {
        if(res.code === 200) {
          if(deleteFlag) {
            this.$message.success("删除成功");
          } else {
            this.$message.success("编辑成功");
          }

          if(flag) {
            this.getInfo(false)
          }
        } else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.$modal.closeLoading();
      });
    },
    solutionDocChange(e) {
      this.solutionDocChooseList = e;
    },
    neutralSolutionDocChange(e) {
      this.neutralDocChooseList = e;
    },
    handleDeletes(flag) {
      let list = [];
      if(flag === 1) {
        list = this.neutralDocChooseList;
      } else {
        list = this.solutionDocChooseList;
      }

      if(!list.length) {
        this.$message.warning("请选择需要批量删除的数据！");
        return;
      }

      this.$confirm("确认删除所选附件吗 ?", "提示")
        .then(async () => {
          list.forEach(item => {
            const index = this.queryParams.findIndex(chid => {
              return chid.id === item.id
            })

            if(index !== -1) {
              this.queryParams.splice(index, 1)
              this.submit(true, true)
            }
          })
        })
    },
    uploadFactoryDoc(e, type) {
      this.queryParams.push({
        fileName: e.url,
        name: e.name,
        fileType: type
      })

      this.submit(true)
    }
  }
};
</script>
<style scoped lang="less">
.plan-read-info-view {
  .info-title {
    margin-top: 20px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .plan-read-info-block {
    border-bottom: 20px solid #d8efff;

    &:last-child {
        border-bottom: 0;
    }
  }
}
</style>
